// ============================================================================
// FILE: src/modules/invoice/components/ExtractedFieldViewer.jsx
// CREATED: 2025-12-03
// PURPOSE: Display invoice extracted header fields in a clean card layout.
// COMMENTS:
// - Works in both Upload flow and Detail view
// - Shows data as read-only labels
// - Later can be enhanced to editable form for validation
// ============================================================================

import React from "react";

const ExtractedFieldViewer = ({ data }) => {
  if (!data) return <p>No extracted data found.</p>;

  // Safe destructuring with fallbacks
  const {
    invoice_number,
    invoice_date,
    vendor_name,
    total_amount,
    gst_amount,
    currency,
  } = data;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">Invoice Number</label>
        <div className="font-medium">{invoice_number || "-"}</div>
      </div>

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">Invoice Date</label>
        <div className="font-medium">{invoice_date || "-"}</div>
      </div>

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">Vendor Name</label>
        <div className="font-medium">{vendor_name || "-"}</div>
      </div>

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">Total Amount</label>
        <div className="font-medium">
          {total_amount ? `${currency || ""} ${total_amount}` : "-"}
        </div>
      </div>

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">GST / Tax Amount</label>
        <div className="font-medium">{gst_amount || "-"}</div>
      </div>

      <div className="p-3 border rounded bg-gray-50">
        <label className="text-sm text-gray-600">Currency</label>
        <div className="font-medium">{currency || "-"}</div>
      </div>

    </div>
  );
};

export default ExtractedFieldViewer;
